<template>
  <div class="dashboard-widget-content">
    <template v-if="!value.ShowOptions">
      <table style="width: 100%">
        <thead>
        <tr class="bold">
          <td>Транспорт</td>
          <td>Отправлено</td>
          <td>% доставки</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items">
          <td class="">{{ item.transport }}</td>
          <td>{{ item.sent }}</td>
          <td :class="getClassName(item.percent)">{{ item.percent }} %</td>
        </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <widget-options>
        <md-field>
          <label>{{ $t('widget.options.update') }}</label>
          <md-select v-model="options.update">
            <md-option :value="10">10 мин</md-option>
            <md-option :value="0">Нет</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.interval') }}</label>
          <md-select v-model="options.interval">
            <md-option value="hour">предыдущий час</md-option>
            <md-option value="today">сегодня</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.direction') }}</label>
          <md-select v-model="options.direction">
            <md-option value="incoming">входящие</md-option>
            <md-option value="outgoing">исходящие</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.chanel') }}</label>
          <md-select id="filter_group_by" v-model="options.transport" multiple>
            <md-option v-for="transport in this.$store.getters.transports" :value="transport.name" :key="transport.id">
              {{ transport.name }}
            </md-option>
          </md-select>
        </md-field>
      </widget-options>
    </template>
  </div>
</template>

<script>
import widgetMixin from './mixin'
import {StatisticsSummary} from "@/services/Widgets";
import {DateTime} from 'luxon'

export default {
  props: {
    value: {}
  },
  mixins: [widgetMixin],
  data() {
    return {
      options: {
        update: 10,
        interval: 'hour',
        direction: 'outgoing',
        transport: 'SMS',
        date_from: '',
        date_to: '',
      },
      items: [],
      timer: null,
    }
  },
  methods: {
    title() {
      let title = '';

      switch (this.options.interval) {
        case 'hour':
          title += 'С ' + DateTime.fromISO(this.options.date_from).toFormat('HH:mm');
          title += ' до ' + DateTime.fromISO(this.options.date_to).toFormat('HH:mm');
          break;
        case 'today':
          title += 'Сегодня';
          break;
      }
      switch (this.options.direction) {
        case 'outgoing':
          title += ' отправлено';
          break;
        case 'incoming':
          title += ' получено';
          break;
      }
      return title;
    },
    getClassName(percent) {
      if (percent > 0 && percent <= 75) {
        return 'text-danger';
      } else if(percent > 75 && percent <= 90) {
        return 'text-warning';
      } else if(percent > 90) {
        return 'text-success';
      }
    },
    async getData() {
      switch (this.options.interval) {
        case 'hour':
          this.options.date_from = DateTime.local().plus({hour:-1}).toISO();
          this.options.date_to = DateTime.local().toISO();
          break;
        case 'today':
          this.options.date_from = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).toISO();
          this.options.date_to = DateTime.local().set({second: 0, millisecond: 0}).toISO();
          break;
      }

      let filter = {
        date_from: this.options.date_from,
        date_to: this.options.date_to,
        direction: this.options.direction,
        transport: this.options.transport,
      };

      let response = await StatisticsSummary(filter);
      // response.data.summary = [
      //   {
      //     "transport": 'SMS',
      //     "sent": 7000,
      //     "delivered": 1000,
      //   },
      //   {
      //     "transport": 'Push',
      //     "sent": 10000,
      //     "delivered": 9700
      //   },
      //   {
      //     "transport": 'Call',
      //     "sent": 10,
      //     "delivered": 8
      //   },
      //   {
      //     "transport": 'Viber',
      //     "sent": 2500,
      //     "delivered": 2500,
      //   },
      //   {
      //     "transport": 'Email',
      //     "sent": 1,
      //     "delivered": 1,
      //   },
      // ];
      if (response.data && response.data.summary) {
        this.items = response.data.summary.map((item) => {
          item.percent = (item.delivered > 0) ? (item.delivered / item.sent * 100).toFixed() : 0;
          return item;
        });
      }

      this.updateTitle();
    },
    intervalFunc() {
      clearInterval(this.timer);
      const update = (60000 * parseInt(this.options.update)) || 0;
      if (update > 0) {
        this.getData();
        this.timer = setInterval(() => this.getData(), update);
      }
    }
  },
  watch: {
    'options'() {
      this.intervalFunc();
    }
  },
  mounted() {
    this.intervalFunc();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
</script>

<style type="text/css">
.bold {
  font-weight: bold;
}
</style>
